import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT } from "const"
import { MarkovState } from "server/models"
import {
    PRM_MARKOV_MODEL,
    StoreType,
    MarkovExpressionConvertToView,
    addModal,
} from "client/store"
import { hasAccess } from "client/utils"
import {
    Link,
    TableColumn,
} from "client/components"

import EditRedistributionState from "client/pages/markov/redistributionStateTo/edit"

const Columns = () => {
    const variableList = useSelector((state: StoreType) => state.markovVariable.variableList)
    const redistributionStateList = useSelector((state: StoreType) => state.markovRedistributionState.to.stateList)
    const calculatedExpressions = useSelector((state: StoreType) => state.markovRedistributionState.to.calculatedExpressions)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editModelAccess = hasAccess(PRM_MARKOV_MODEL, EDIT)

    const columns: TableColumn[] = [
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "300px",
            formatter: (state: MarkovState) => (
                editModelAccess
                    ? (
                        <Link
                            href="/#"
                            onClick={() => dispatch(addModal({
                                key: "editRedistributionState",
                                content: <EditRedistributionState stateId={state.id} />,
                            }))}
                        >
                            {state.name}
                        </Link>
                    )
                    : state.name
            ),
        },
        {
            field: "expression",
            header: lang.expression,
            cellMinWidth: "200px",
            formatter: (state: MarkovState) => {
                const redistributionState = redistributionStateList[state.id]
                if (redistributionState) return MarkovExpressionConvertToView(redistributionState.expression, variableList)
                return null
            },
        },
        {
            field: "calculatedValue",
            header: lang.value,
            cellMinWidth: "200px",
            formatter: (state: MarkovState) => (
                calculatedExpressions[state.id] !== undefined ? calculatedExpressions[state.id] : null
            ),
        },
        {
            field: "order",
            header: lang.order,
            sortable: true,
            cellMinWidth: "100px",
        },
    ]

    if (editModelAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
